/* eslint-disable max-lines-per-function */
import React from "react";
import * as yup from "yup";
import $ from "jquery";
import { Menu, MenuItem, Checkbox, DialogContent, Grid, Typography, Tooltip } from "@material-ui/core";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Form, Formik } from "formik";
import { Button, Modal } from "components/haven-design";
import { InputWithErrorLabel } from "components/haven-design/form/inputs";
import { DialogActions } from "components/haven-design/modal/dialog";
import { useInterestsTable } from "../interests-table/table-context";
import { useSidebarFilters } from "../sidebar-filters";
import styles from "./button-select-interests.module.css";

const SelectAllButton: React.FC<{isChecked: boolean}> = () => {
  const {
    replaceAllSelection,
    fullPageOrAllPagesSelected,
    selectedSomeInterests,
    selectedPageRange,
    selectPageRange,
    selectAllInterests,
  } = useInterestsTable();
  const { pageState: { page, nbPages } } = useSidebarFilters();
  const currentPage = page;

  const { from: mobxFrom, to: mobxTo } = selectedPageRange;
  const [rangeModalOpen, setRangeModalOpen] = React.useState(false);
  const [tooltipOpen, setTooltipOpen] = React.useState(false);
  const toggleRangeModal = () => setRangeModalOpen(!rangeModalOpen);
  const handleSelectCurrentPage = () => {
    const checkboxes = $("span[data-component=\"SelectRowCheckbox\"");
    const interestIds = checkboxes.map((_i, el) => el.dataset.rid).toArray();
    replaceAllSelection([...interestIds]);
  };
  const handleSelectAll = () => {
    const checkboxes = $("span[data-component=\"SelectRowCheckbox\"");
    const visibleIds = checkboxes.map((_i, el) => el.dataset.rid).toArray();
    selectAllInterests(visibleIds);
  };

  const handleDeselectAll = () => {
    replaceAllSelection([]);
  };
  // checkbox next to dropdown
  const handleTogglePage = () => {
    if (fullPageOrAllPagesSelected) {
      handleDeselectAll();
    } else {
      handleSelectCurrentPage();
    }
  };
  const doSelectPageRange = ({ from, to }: {from: string, to: string}) => {
    if (from === "" && to === "") return;
    const fromNumber = from === "" ? 0 : parseInt(from, 10) - 1;
    const toNumber = to === "" ? nbPages - 1 : parseInt(to, 10) - 1;

    const checkboxes = $("span[data-component=\"SelectRowCheckbox\"");
    const visibleIds = (currentPage < fromNumber || currentPage > toNumber) ? [] : (
      checkboxes.map((_i, el) => el.dataset.rid).toArray());
    selectPageRange({ visibleIds, from: fromNumber, to: toNumber, totalPages: nbPages });
    toggleRangeModal();
  };

  return (
    <>
      <PopupState variant="popover" popupId="select-interests-popup-menu">
        {(popupState) => {
          const { onClick, ...rest } = bindTrigger(popupState);
          const updatedOnClick = (event: React.SyntheticEvent<any, Event>) => {
            setTooltipOpen(false);
            onClick(event);
          };
          const updatedTrigger = { ...rest, onClick: updatedOnClick };
          return (<>
            <Tooltip title="Select Applications" open={tooltipOpen}
              onOpen={() => {
                if (!popupState.isOpen) setTooltipOpen(true);
              }}
              onClose={() => setTooltipOpen(false)}>
              <div className={styles.container}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                    justifyContent: "space-between",
                    padding: "0 10px",
                  }}
                  {...updatedTrigger}
                  className={styles.icon}>
                  <Checkbox
                    size="small"
                    checked={fullPageOrAllPagesSelected}
                    indeterminate={selectedSomeInterests && !fullPageOrAllPagesSelected}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleTogglePage();
                    }}
                    style={{ padding: 0 }}
                  />
                  <span style={{
                    fontWeight: 800,
                    color: "#B8B8B8",
                    textAlign: "center",
                    flex: 1,
                    paddingLeft: 3,
                  }}>
                    Select
                  </span>
                  <ExpandMoreIcon fontSize="small" id="select-open-arrow" />
                </div>
                <Menu {...bindMenu(popupState)}>
                  <MenuItem onClick={() => {
                    popupState.close();
                    handleSelectAll();
                  }}>Select All</MenuItem>
                  <MenuItem onClick={() => {
                    popupState.close();
                    handleSelectCurrentPage();
                  }}>Select Current Page</MenuItem>
                  <MenuItem onClick={() => {
                    popupState.close();
                    toggleRangeModal();
                  }}>Select Page Range</MenuItem>
                  <MenuItem onClick={() => {
                    handleDeselectAll();
                    popupState.close();
                  }}>Select None</MenuItem>
                </Menu>
              </div>

            </Tooltip>
          </>);
        }}
      </PopupState>
      <Modal
        isOpen={rangeModalOpen}
        onRequestClose={toggleRangeModal}
        fullWidth
        maxWidth="sm"
        title="Select Page Range">
        <Formik
          initialValues={{
            from: (mobxFrom ? `${mobxFrom + 1}` : (currentPage + 1).toString()),
            to: (mobxTo === null ? `${nbPages}` : `${mobxTo + 1}`),
          }}
          validationSchema={yup.object().shape({
            from: yup.number().min(1, "Must be at least 1")
              .max(nbPages, "Must be less or equal than the number of pages"),
            to: yup.number().min(1, "Must be at least 1")
              .max(nbPages, "Must be less or equal than the number of pages")
              .when("from", (from: any, schema: any) =>
                (from ? schema.min(from, "Must be greater or equal to from") : schema)),
          })}

          onSubmit={doSelectPageRange}
        >
          {({ values, errors }) => (<>
            <DialogContent>
              <Form id="select-page-range">
                <Grid container spacing={2}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <InputWithErrorLabel
                        fullWidth
                        variant="outlined"
                        label="From"
                        type="number"
                        name="from"
                        value={values.from}
                        inputProps={{ min: 1, max: nbPages }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputWithErrorLabel
                        fullWidth
                        variant="outlined"
                        label="To"
                        type="number"
                        name="to"
                        value={values.to}
                        inputProps={{ min: values.from ? (parseInt(values.from, 10)) : "1", max: nbPages }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body2" color="textSecondary">
                      Current page: {page + 1}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                      Total pages: {nbPages}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Form>
            </DialogContent>
            <DialogActions>
              <Button type="submit"
                form="select-page-range"
                color="primary"
                size="L"
                disabled={!!errors.from || !!errors.to}
              >Select</Button>
            </DialogActions>
          </>
          )}
        </Formik>
      </Modal>
    </>
  );
};


export default SelectAllButton;
